import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { InParkingCardDetail } from 'src/features/cards/types/card';

const RESOURCE = '/parkings/:parkingId/cards/in-parking/:cardId/make-guest/';

type MakeGuestInParkingCardFnType = typeof makeGuestInParkingCard;

export type MakeGuestInParkingCardDTO = {
    parkingId: string;
    cardId: number;
    reason: string | null;
};

const makeGuestInParkingCard = ({
    parkingId,
    cardId,
    ...data
}: MakeGuestInParkingCardDTO): Promise<InParkingCardDetail> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, cardId }), data);
};

interface UseMakeGuestInParkingCardOptions
    extends MutationConfig<MakeGuestInParkingCardFnType, GeneralSmartParkError> {}

export const useMakeGuestInParkingCard = (options: UseMakeGuestInParkingCardOptions) =>
    useMutation({
        mutationFn: makeGuestInParkingCard,
        ...options,
    });
